import { firestoreInstance, CACHE_SIZE_UNLIMITED } from './fbase';

// const firestoreInstance = firebase.firestore();
firestoreInstance.settings({ cacheSizeBytes: CACHE_SIZE_UNLIMITED });
firestoreInstance.enablePersistence()
// firestoreInstance.disableNetwork()

export default firestoreInstance;